export { default } from './aliyun/getAliyunOssSign'
